import { api } from "../../lib/api";

export interface MediaFile {
  id: string | number;
  name: string;
  file: string;
  thumbnail?: string;
  file_type: "image" | "video" | "other";
  description?: string;
  alt_text?: string;
  tags?: string[];
  uploaded_at: string;
  file_size: number;
  dimensions?: { width: number; height: number };
  usage_count: number;
  source?: "marketing" | "production";
  source_app_display?: string;
  favorite?: boolean;
  collections?: number[];
  original_filename?: string;
  mime_type?: string;
  job_id?: number;
}
export interface MediaCollection {
  id: number;
  name: string;
}
export interface MediaPage {
  count: number;
  results: MediaFile[];
  facets: { tags: string[] };
}
export interface MediaUsage {
  references: { kind: string; id: string; name: string }[];
  can_delete: boolean;
  scope: string;
}
export interface BulkResult {
  changed: string[];
  skipped: { id: string; reason: string }[];
}
export interface UploadResult {
  count: number;
  uploaded: { id: number; upload_index?: number }[];
  errors?: { index: number; file: string; error: string }[];
  duplicates?: { index: number; file: string; id: number; name: string }[];
}
export const mediaError = (error: unknown) =>
  error instanceof Error
    ? error.message
    : "The request failed. Please try again.";
export const tagNames = (value: string) => [
  ...new Set(
    value
      .split(",")
      .map((v) => v.trim())
      .filter(Boolean),
  ),
];
export const bulkMedia = async (data: Record<string, unknown>) =>
  (await api.post<BulkResult>("/api/marketing/combined-media/bulk/", data))
    .data;
